var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-steps", {
    style: _vm.stepStyle,
    attrs: {
      type: "navigation"
    },
    model: {
      value: _vm.current,
      callback: function ($$v) {
        _vm.current = $$v;
      },
      expression: "current"
    }
  }, [_c("a-step", {
    attrs: {
      status: _vm.current == 0 ? "process" : "finish",
      title: _vm.$t("填写理赔信息"),
      disabled: ""
    }
  }), _c("a-step", {
    attrs: {
      status: "process",
      title: _vm.$t("上传理赔资料"),
      disabled: ""
    }
  })], 1), _c("information", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.current == 0,
      expression: "current == 0"
    }],
    on: {
      next: _vm.nextFun
    }
  }), _c("materials", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.current == 1,
      expression: "current == 1"
    }],
    on: {
      back: function ($event) {
        _vm.current = 0;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };